import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import ListVacantPositions from "./List";
import EditVacantPositions from "./Edit";
import CreateVacantPositions from "./Create";
import ShowVacantPositions from "./Show";
//params
export const VACANT_POSITIONS = "vacant-positions";

//permissions

export const resources = {
  isMenu: true,
  icon: <PersonSearchIcon />,
  name: VACANT_POSITIONS,
  title: "Свободни позиции",
  list: <ListVacantPositions />,
  edit: <EditVacantPositions />,
  create: <CreateVacantPositions />,
  show: <ShowVacantPositions />,
  permission: "vacantPositions",
};

//api url
